import React from 'react';
import ReactDOM from 'react-dom';


import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../node_modules/react-datetime/css/react-datetime.css'
import UnRideItClient from './unrideit'
import NetworkViewer from './network-viewer'

function AccessViewerWrapper(props) {
    const params = new URLSearchParams(window.location.search);
    const networkId = params.get("network");
    const initialCenter = params.get("center");
    const initialCoords = initialCenter.split(",");
    const initialLat = initialCoords[0];
    const initialLon = initialCoords[1];
    const excludeListString = params.get("exclude") || "";
    const excludeList = excludeListString.split(",")

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
            <NetworkViewer
                networkId={networkId}
                unRideIt={new UnRideItClient()}
                initialLat={initialLat}
                initialLon={initialLon}
                excludeList={excludeList}
            />
        </div>
    )
}

const element = document.getElementById('root');
const viewer = (<AccessViewerWrapper />);
ReactDOM.render(viewer, element)
